export default __webpack_public_path__ + "static/Homekit_1080p_Smartphone_01-01aeebd5a72c1b09bd48859ab11cad9f.webp";